import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import "../../cssfiles/homepage.css";
import CustomLabel from "../CommonComponents/CustomLabel";
import {
  exportAndEmailReport,
  exportPdfReport,
  generateReportStandard,
  getDevicesReportGen,
  getEntireTemplateTree,
} from "../../Restclient/datacollection";
import CustomButton from "../CommonComponents/CustomButton";
import { useSelector } from "react-redux";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomTimePeriod from "../CommonComponents/CustomTimePeriod";
import CustomTreeSelect from "../CommonComponents/CustomTreeSelect";
import ReportViewerApp from "./ReportViewer";
import LK_Loading from "../../images/LK_Loading.gif";
import "../../cssfiles/reports.css";
import CustomMultiselectWithCheckbox from "../CommonComponents/CustomMultiselectWithCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";

function dateToEpoch(date) {
  return new Date(date).getTime() / 1000;
}

export default function Generate() {
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const theme = useSelector((state) => state.themedata.theme);

  const [selectedGroupVal, setSelectedGroupVal] = useState("");
  const [groupTree, setGroupTree] = useState([]);
  const [designer, setDesigner] = useState(false);
  const [designerType, setDesignerType] = useState("Standard");

  const restCallbackGroupTree = (res) => {
    setGroupTree(res.data);
  };

  useEffect(() => {
    getEntireTemplateTree(restCallbackGroupTree);
  }, [projectId]);

  const [selectedGroup, setSelectedGroup] = useState("");

  const [templateList, setTemplateList] = useState([]);
  const [templateDynamic, setTemplateDynamic] = useState([]);
  const [templateType, setTemplateType] = useState([]);
  const [templateInterval, setTemplateInterval] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [dynamicTemp, setDynamicTemp] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [deviceListID, setDeviceListID] = useState([]);
  const [orientation, setOrientation] = useState("Portrait");
  const [table_rows, setTable_rows] = useState([]);
  const [documentType, setDocumentType] = useState("PDF");

  const getSelectedDeviceIDs = (selectedDevices) => {
    return selectedDevices.map((deviceName) => {
      const index = deviceList.indexOf(deviceName);
      return deviceListID[index];
    });
  };
  useEffect(() => {
    getDevicesReportGen(selectedGroupVal.split("/")[0], (res) => {
      setDeviceList(res.data.devices.map((device) => device.Name));
      setDeviceListID(res.data.devices.map((device) => device.DeviceID));
      setDynamicTemp(res.data.dynamic);
      setTable_rows(res.data.taglist);
    });
    setSelectedDevices([]);
  }, [selectedGroupVal]);

  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const [dynamic, setDynamic] = useState(false);
  const [tempType, setTempType] = useState("Archive");
  const handleTemplateChange = (value) => {
    setSelectedTemplate(value);
    setDynamic(templateDynamic[templateList.indexOf(value)]);
    setTempType(templateType[templateList.indexOf(value)]);
    setSelctedTimePeriod(templateInterval[templateList.indexOf(value)]);
  };

  const [selectedTimePeriod, setSelctedTimePeriod] = useState("Today");
  const now = new Date();
  const [startDT, setStartDT] = useState(
    new Date(now.setHours(0, 0, 0, 0)).toString(),
  );
  const [endDT, setEndDT] = useState(new Date().toString());
  const handleDateTime = (startdate, enddate) => {
    setStartDT(startdate);
    setEndDT(enddate);
  };

  const [update, setUpdate] = useState(-1);

  useEffect(() => {
    const timer = setTimeout(() => {
      setUpdate(-1);
    }, 3000);
    return () => clearTimeout(timer);
  }, [update]);

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [reportView, setReportView] = useState(false);
  const [file, setFile] = useState();

  const handleClose = (event, reason) => {
    if (reason === "closeButton") {
      setReportView(false);
      setFile();
    }
  };

  const callbackemail = (res) => {
    return;
  };

  const callbackReport = (resfile, docType) => {
    setIsDataLoading(false);

    if (docType === "Excel") {
      // Trigger a direct download — browsers can't preview xlsx inline
      const blob = new Blob([resfile], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${selectedGroupVal.split("/")[0]}_report.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } else {
      // Existing PDF flow — opens in the dialog
      const blob = new Blob([resfile], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setFile(url);
    }
  };

  const handleGenerateReport = () => {
    if (selectedGroupVal === "" || startDT === "" || endDT === "") {
      setUpdate(3);
      return;
    }
    setIsDataLoading(true);
    generateReportStandard(
      selectedTimePeriod,
      selectedGroupVal.split("/")[0],
      startDT.toString(),
      endDT.toString(),
      getSelectedDeviceIDs(selectedDevices),
      orientation,
      documentType,
      callbackReport,
    );
    if (documentType === "PDF") setReportView(true);
  };

  const callbackexportReport = (res) => {
    return;
  };

  const [currDate, setCurrDate] = useState(new Date().toString());
  useEffect(() => {
    if (designer) {
      exportPdfReport(
        selectedGroupVal.split("/")[0] +
          "/" +
          dateToEpoch(startDT) +
          "/" +
          dateToEpoch(endDT),
        dateToEpoch(startDT),
        dateToEpoch(endDT),
        currDate,
        callbackexportReport,
      );
    }
  }, [designer]);

  if (designer) {
    return (
      <div className="templateGroup">
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "right",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CustomCancelButton
                buttonText={"Close"}
                onClick={() => setDesigner(false)}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CustomButton
                buttonText={"Email"}
                onClick={() =>
                  exportAndEmailReport(
                    selectedGroupVal.split("/")[0] +
                      "/" +
                      dateToEpoch(startDT) +
                      "/" +
                      dateToEpoch(endDT),
                    callbackemail,
                  )
                }
              />
            </Box>
          </Box>
          <ReportViewerApp
            url={selectedGroupVal}
            startDate={startDT}
            endDate={endDT}
          />
        </Box>
      </div>
    );
  }

  return (
    <div className="templateGroup">
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "right",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <CustomButton
              buttonText={"Generate"}
              onClick={() => {
                if (designerType === "Custom") {
                  setCurrDate(new Date().toString());
                  setDesigner(true);
                } else {
                  handleGenerateReport();
                }
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <CustomCancelButton buttonText={"Cancel"} />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            {update === 1 ? (
              <CustomLabel labelText={"Update Successfull!"} color={"green"} />
            ) : update === 0 ? (
              <CustomLabel labelText={"Update Unsuccessfull!"} color={"red"} />
            ) : update === 2 ? (
              <CustomLabel labelText={"Already Linked!"} />
            ) : update === 3 ? (
              <CustomLabel
                labelText={"Select all the required fields!"}
                color={"red"}
              />
            ) : (
              <></>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            gap: "8px",
            padding: "8px",
            backgroundColor: "var(--PrimaryBackground)",
            boxSizing: "border-box",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              width: "50%",
              height: "100%",
              // display: "flex",
              // flexDirection: "column",
              // alignItems: "left",
              // gap: "32px",
              padding: "8px",
              backgroundColor: "var(--SecondaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <table width="100%" className="generate-table">
              <tr>
                <td className="generate-table-td-left">
                  <CustomLabel
                    labelText={"Template*"}
                    htmlFor={"template-group"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} className="generate-table-td">
                  <CustomTreeSelect
                    options={groupTree}
                    value={selectedGroupVal}
                    onChange={(val, item) => {
                      setSelectedGroupVal(val);
                      setDesignerType(item.designer);
                    }}
                    disabledItemValues={(item) => item.type === "group"}
                    placeholder=""
                    width="227px"
                    fontSize="16px"
                  />
                </td>
              </tr>
              <tr>
                <td className="generate-table-td-left">
                  <CustomLabel
                    labelText={"Time Period*"}
                    htmlFor={"time-period"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} className="generate-table-td">
                  <CustomTimePeriod
                    setDateTime={handleDateTime}
                    width={227}
                    setSelectedOption={(val) => setSelctedTimePeriod(val)}
                    defaultValue={"Today"}
                  />
                </td>
              </tr>
              <tr>
                <td className="generate-table-td-left">
                  <CustomLabel
                    labelText={"Devices*"}
                    htmlFor={"devices"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} className="generate-table-td">
                  <CustomMultiselectWithCheckbox
                    options={deviceList}
                    selecteddata={selectedDevices}
                    disabled={dynamicTemp === false ? true : false}
                    onChange={(val) => setSelectedDevices([...val])}
                  />
                </td>
              </tr>
              <tr>
                <td className="generate-table-td-left">
                  <CustomLabel
                    labelText={"Document Type*"}
                    htmlFor={"document-type"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} className="generate-table-td">
                  <CustomDropDown
                    options={["PDF", "Excel"]}
                    defaultValue={"PDF"}
                    onChange={(val) => setDocumentType(val)}
                  />
                </td>
              </tr>
              <tr
                style={{
                  visibility: documentType === "PDF" ? "visible" : "hidden",
                }}
              >
                <td className="generate-table-td-left">
                  <CustomLabel
                    labelText={"Orientation*"}
                    htmlFor={"orientation"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td colSpan={2} className="generate-table-td">
                  <CustomDropDown
                    options={["Portrait", "Landscape"]}
                    defaultValue={"Portrait"}
                    onChange={(val) => setOrientation(val)}
                  />
                </td>
              </tr>
            </table>
          </Box>
          <Box
            sx={{
              width: "50%",
              height: "100%",
              // display: "flex",
              // flexDirection: "column",
              // alignItems: "left",
              // gap: "32px",
              padding: "8px",
              backgroundColor: "var(--SecondaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                width: "780px",
                height: "600px",
                paddingLeft: "0px",
                backgroundColor: "var(--secondary-backgroundLK)",
                paddingRight: "0px",
              }}
              elevation={0}
            >
              <Table stickyHeader sx={{ width: "100%" }} size="small">
                <TableHead>
                  <TableRow sx={{ border: "0px" }}>
                    <TableCell
                      sx={{
                        // width: "15%",
                        textAlign: "left",
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "var(--grey-variation-tableLK)",
                        backgroundColor: "var(--secondary-backgroundLK)",
                      }}
                    >
                      Taglist
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {table_rows?.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "9px",
                        "& > *": {
                          borderBottom: "1px solid var(--table-boarder-line)",
                        },
                      }}
                    >
                      <TableCell
                        colSpan={2}
                        key={index}
                        component="th"
                        scope="row"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "var(--grey-variation-tablerowsLK)",
                        }}
                      >
                        {row}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
      {
        <Dialog
          maxWidth={"xl"}
          open={reportView}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClose(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            sx: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#5B5B5B",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  Report
                </Typography>
                <Box sx={{ flexGrow: 1 }}> </Box>

                <Button
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    width: "60px",
                    height: "30px",
                    borderRadius: "20px",
                    borderColor: "#5B5B5B",
                    color: "#5B5B5B",
                  }}
                  onClick={(event) => handleClose(event, "closeButton")}
                >
                  {" "}
                  Close{" "}
                </Button>
              </Box>
              {isDataLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "calc(100vh - 200px)",
                    width: "1000px",
                  }}
                >
                  <img
                    src={LK_Loading}
                    alt="Loading..."
                    className="loading-popup" // Adjust size here
                  />
                </Box>
              ) : (
                <iframe
                  className="Test 123 iframe-report"
                  src={file}
                  type="application/pdf"
                  width="1000px"
                  aria-label="PDF file"
                ></iframe>
              )}
            </>
          </DialogContent>
        </Dialog>
      }
      {isDataLoading && documentType === "Excel" && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor:
              theme === "dark" ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <img src={LK_Loading} alt="Loading..." className="loading-popup" />
            <Typography
              sx={{ color: "#fff", fontSize: "14px", fontWeight: 500 }}
            >
              Preparing Excel report...
            </Typography>
          </Box>
        </Box>
      )}
    </div>
  );
}
